<template>
  <div>
    <v-container grid-list-xl fluid class="white pl-6 pr-5 pt-6">
      <v-layout row wrap class="pr-5 pl-2 mb-2">
        <v-flex class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            Consolidated Report
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-breadcrumbs
          class="
            px-0
            fs-12
            lh-15
            py-0
            breadcrumbs-items
            custom-breadcrumbs
            text-uppercase
          "
          :items="breadcrumbs"
        ></v-breadcrumbs>

        <v-flex xs12 class="pa-0 grey--text font-weight-500 fs-12 lh-16">
          <v-row class="px-3">
            <v-expansion-panels flat class="filterby-info">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="primary--text fs-13 px-0 pl-3 pt-0 pb-1"
                  height="100px"
                >
                  Filter By Information
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey--text">
                  <!-- {{ yearInfo }} -->
                  <ul v-if="filterBy[0] !== '-'">
                    <li
                      v-for="(filter, indexFilter) in filterBy"
                      :key="'filter' + indexFilter"
                      class="text-left"
                    >
                      {{ yearInfo + ' / ' + filter }}
                    </li>
                  </ul>
                  <ul v-else>
                    <li>{{ yearInfo }}</li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-flex>
      </v-layout>
      <!-- summary total amount -->
      <v-layout row wrap class="px-5 mt-3">
        <v-expansion-panels
          flat
          v-model="panelSummary"
          multiple
          class="summary-collapse rounded-0"
          :class="panelSummary.length > 0 ? '' : 'border-y-2'"
        >
          <v-expansion-panel class="rounded-0">
            <v-expansion-panel-content>
              <v-flex xs12 class="py-0">
                <v-row class="spending-info pa-0">
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="teal"
                      :typeCard="1"
                      :value1="summary.totalBudget"
                      :valueEur="summary.totalBudgetEuro"
                      text="TOTAL BUDGET"
                      textColor="teal--text"
                      style="border-right: 1px solid #bdbdbd !important"
                    ></summary-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="softRed"
                      textColor="softRed--text"
                      :typeCard="2"
                      :value1="summary.totalSpending"
                      :valueTotal="summary.totalBudget"
                      :valueEur="summary.totalSpendingEuro"
                      text="TOTAL SPENDING IO"
                      style="border-right: 1px solid #bdbdbd !important"
                    ></summary-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="bluePurple"
                      textColor="bluePurple--text"
                      :typeCard="3"
                      :value1="summary.remaining"
                      :valueTotal="summary.totalBudget"
                      :valueEur="summary.remainingEuro"
                      text="TOTAL REMAINING BUDGET"
                    ></summary-amount>
                  </v-col>
                </v-row>
              </v-flex>
            </v-expansion-panel-content>
            <v-expansion-panel-header class="py-2">
              <template v-slot:actions class="mx-auto">
                <v-icon
                  color="bluedarken"
                  style="font-size: 23px !important"
                  class="mx-auto"
                >
                  keyboard_arrow_down
                </v-icon>
              </template>
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
      <!-- /summary total amount -->
    </v-container>

    <template v-if="items.length === 0">
      <v-layout class="mt-3 px-8">
        <v-flex xs12>
          <v-card class="pb-4 rounded-10 elevation-card">
            <v-card-title class="primary pa-2 white--text">
              <span id="titleBrand" class="title pl-2"></span>
              <v-spacer></v-spacer>
              <v-icon class="mr-4" color="white" id="removeBudget">
                keyboard_arrow_down
              </v-icon>
              <v-icon
                color="white"
                class="mr-2"
                id="refreshBudget"
                @click="refresh()"
                >refresh</v-icon
              >
            </v-card-title>
            <v-card-text class="pa-3">
              <v-layout row wrap class>
                <v-flex xs12 class="py-0 pt-4 text-center">
                  No data displayed
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
    <v-layout v-else class="tab-consolidated">
      <v-tabs v-model="tab" background-color="white" color="menuActive">
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(tab, index) in items"
          :key="index"
          class="text-left px-0 d-block pt-3 mr-10"
          style="min-width: 100px !important; height: 100%"
          @click="changeTab(tab)"
        >
          <span class="text-capitalize fs-12 font-weight-600 text-left">
            {{ tab.name }}
          </span>
        </v-tab>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mt-2" @click="downloadData">
          <v-icon size="10px">mdi-download </v-icon> Download
        </v-btn>
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(item, indextab) in items"
            :key="indextab"
            class="px-8"
          >
            <v-card class="pb-3 mb-10 rounded-10 elevation-card mt-4">
              <v-card-title>
                <span
                  class="
                    font-weight-700
                    fs-20
                    lh-16
                    pl-1
                    bluedarken--text
                    text-uppercase
                  "
                  style="align-self: center"
                >
                  {{ item.name }}
                </span>
                <v-spacer></v-spacer>
                <v-icon
                  color="bluedarken"
                  style="font-size: 22px !important"
                  id="refreshBudget"
                  @click="refresh()"
                >
                  refresh
                </v-icon>
              </v-card-title>
              <v-card-text class="px-3 py-2 consolidate-monthly">
                <v-col sm="12" class="px-2">
                  <v-data-table
                    class="mt-1 nav-table table-po po-monitoring-table"
                    :headers="headers"
                    :items="item.data.dataIO"
                    :options.sync="item.data.options"
                    :server-items-length="item.data.totalItems"
                    :footer-props="{
                      itemsPerPageOptions: [10, 25, 50, 100]
                    }"
                  >
                    <template v-slot:header>
                      <thead>
                        <tr>
                          <th class="f-14 white--text sticky-header1">
                            IO Number
                          </th>
                          <th
                            class="f-14 white--text sticky-header2-consolidate"
                          >
                            Code
                          </th>
                          <th class="f-14 white--text">Year</th>
                          <th class="f-14 white--text">Entity</th>
                          <th class="f-14 white--text">Brand</th>
                          <template v-if="item.data.dataIO.length > 0">
                            <th
                              v-for="(group, idxGroup) in item.data.dataIO[0]
                                .level"
                              :key="'group-' + idxGroup"
                              class="text-capitalize f-14 white--text"
                            >
                              <span v-if="group.name">
                                {{ group.name || '-' }}
                              </span>
                              <span v-else>-</span>
                            </th>
                          </template>
                          <th class="f-14 white--text">Product Hierarchy</th>
                          <th class="f-14 white--text">Budget Owner</th>
                          <th class="f-14 white--text" v-if="isLoggedInAsSales">
                            Channel
                          </th>
                          <th class="f-14 white--text" v-if="isLoggedInAsSales">
                            Account
                          </th>
                          <th class="f-14 white--text text-center">PIC</th>
                          <th class="f-14 white--text">
                            Cost Center Description
                          </th>
                          <th class="f-14 white--text">Cost Center</th>
                          <th class="f-14 white--text">
                            Cost Element (GL Protein)
                          </th>
                          <th class="f-14 white--text">
                            Cost Element (GL Protein) Desc
                          </th>
                          <th class="f-14 white--text">Material Group</th>
                          <th class="f-14 white--text">Nature Activity</th>
                          <th class="f-14 white--text">Taxonomy Category</th>
                          <th class="f-14 white--text">Working/Non Working</th>
                          <th class="f-14 white--text">Method</th>
                          <th class="f-14 white--text">Campaign</th>
                          <th class="f-14 white--text">BPC Line</th>
                          <th class="f-14 white--text">Start</th>
                          <th class="f-14 white--text">End</th>
                          <th class="f-14 white--text" v-if="isLoggedInAsSales">
                            Investment Type
                          </th>
                          <th class="f-14 white--text">Activity Description</th>
                          <th
                            v-for="(month, index) in months"
                            :key="index"
                            class="f-14 white--text"
                          >
                            {{ month }}
                          </th>
                          <th class="f-14 white--text">PO</th>
                          <th class="f-14 white--text">Non-PO</th>
                          <th class="f-14 white--text">Remaining IO</th>
                          <th class="f-14 white--text">GR</th>
                          <th class="f-14 white--text">Actual Non-PO</th>
                          <th class="f-14 white--text">Remaining PO</th>
                          <th class="f-14 white--text">Remaining Non-PO</th>
                          <th class="f-14 white--text">Status</th>
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:body>
                      <tbody v-if="item.data.dataIO.length > 0">
                        <tr
                          v-for="(val, index) in item.data.dataIO"
                          :key="index"
                        >
                          <td class="sticky-body1">
                            {{ val.io_number ? val.io_number : '-' }}
                          </td>
                          <td class="sticky-body2-consolidate">
                            {{ val.nav_code ? val.nav_code : '-' }}
                          </td>
                          <td>
                            {{ val.year ? val.year : '-' }}
                          </td>
                          <td>
                            {{ val.entity ? val.entity : '-' }}
                          </td>
                          <td>
                            {{ val.brand ? val.brand : '-' }}
                          </td>
                          <template
                            v-for="(groupContent, idxGroupContent) in val.level"
                          >
                            <td
                              :key="'groupContent-' + idxGroupContent"
                              class="text-capitalize"
                            >
                              <span v-if="groupContent.value">
                                {{ groupContent.value || '-' }}
                              </span>
                              <span v-else>-</span>
                            </td>
                          </template>
                          <td>
                            {{
                              val.product_hierarchy
                                ? val.product_hierarchy
                                : '-'
                            }}
                          </td>
                          <td>
                            {{ val.budget_owner ? val.budget_owner : '-' }}
                          </td>
                          <td v-if="isLoggedInAsSales">
                            <v-tooltip bottom v-if="val.channel.length > 30">
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  {{ strLimit(val.channel, 50) }}
                                </span>
                              </template>
                              <span>
                                {{ val.channel }}
                              </span>
                            </v-tooltip>
                            <span v-else>
                              {{ strLimit(val.channel, 50) }}
                            </span>
                          </td>
                          <td v-if="isLoggedInAsSales">
                            <v-tooltip bottom v-if="val.account.length > 30">
                              <template v-slot:activator="{ on }">
                                <span v-on="on">
                                  {{ strLimit(val.account, 50) }}
                                </span>
                              </template>
                              <span>
                                {{ val.account }}
                              </span>
                            </v-tooltip>
                            <span v-else>
                              {{ strLimit(val.account, 50) }}
                            </span>
                          </td>
                          <td>
                            {{ val.pic || '-' }}
                          </td>
                          <td>
                            {{ val.cc_desc || '-' }}
                          </td>
                          <td>
                            {{ val.cost_center || '-' }}
                          </td>
                          <td>
                            {{ val.cost_element || '-' }}
                          </td>
                          <td>
                            {{ val.ce_desc || '-' }}
                          </td>
                          <td>
                            {{ val.material_group || '-' }}
                          </td>
                          <td>
                            {{ val.nature_activity || '-' }}
                          </td>
                          <td>
                            {{ val.taxonomy_category || '-' }}
                          </td>
                          <td class="text-capitalize">
                            {{ val ? val.pillars : '-' }}
                          </td>
                          <td class="text-capitalize">
                            {{ val ? val.method : '-' }}
                          </td>
                          <td>
                            {{ val ? val.campaign || '-' : '-' }}
                          </td>
                          <td>
                            {{ val.bpc_line || '-' }}
                          </td>
                          <td>
                            {{ val.start ? formatDate(val.start) : '-' }}
                          </td>
                          <td>
                            {{ val.start ? formatDate(val.end) : '-' }}
                          </td>
                          <td v-if="isLoggedInAsSales">
                            {{
                              val.investment_type ? val.investment_type : '-'
                            }}
                          </td>
                          <td>
                            {{ val.activity_desc ? val.activity_desc : '-' }}
                          </td>
                          <template v-for="amount in monthsCheck">
                            <td :key="amount" class="text-right">
                              {{ idr(val[amount]) || '-' }}
                            </td>
                          </template>
                          <td class="text-right">
                            {{ val.po ? idr(val.po) : '-' }}
                          </td>
                          <td class="text-right">
                            {{ val.non_po ? idr(val.non_po) : '-' }}
                          </td>
                          <td class="text-right">
                            {{ val.remaining_io ? idr(val.remaining_io) : '-' }}
                          </td>
                          <td class="text-right">
                            {{ val.gr ? idr(val.gr) : '-' }}
                          </td>
                          <td class="text-right">
                            {{
                              val.actual_non_po ? idr(val.actual_non_po) : '-'
                            }}
                          </td>
                          <td class="text-right">
                            {{ val.remaining_po ? idr(val.remaining_po) : '-' }}
                          </td>
                          <td class="text-right">
                            {{
                              val.remaining_non_po
                                ? idr(val.remaining_no_po)
                                : '-'
                            }}
                          </td>
                          <td class="text-uppercase">
                            {{ val.status ? val.status : '-' }}
                          </td>
                        </tr>
                        <tr
                          class="bgTotal"
                          v-if="item.data.options.page === item.data.lastPage"
                        >
                          <td
                            class="
                              sticky-body1
                              border-r-0
                              font-weight-bold
                              sticky-amount sticky-body1
                            "
                            style="z-index: 2 !important"
                          ></td>
                          <td
                            class="
                              font-weight-bold
                              text-right
                              border-l-0
                              sticky-amount sticky-body2-consolidate
                            "
                            style="z-index: 2 !important"
                          >
                            TOTAL
                          </td>
                          <td colspan="3" class="border-x-0 sticky-amount"></td>
                          <template v-if="item.data.dataIO.length > 0">
                            <td
                              v-for="(groupContent, iGroupContent) in item.data
                                .dataIO[0].level"
                              :key="'groupContent-' + iGroupContent"
                              class="border-x-0 sticky-amount"
                            ></td>
                          </template>
                          <td
                            v-if="isLoggedInAsSales"
                            colspan="3"
                            class="border-x-0 sticky-amount"
                          ></td>
                          <td
                            colspan="17"
                            class="border-x-0 sticky-amount"
                          ></td>
                          <template v-if="item.data.itemAmount">
                            <td
                              v-for="month in monthsCheck"
                              class="font-weight-bold text-right sticky-amount"
                              :key="month"
                            >
                              {{ idr(item.data.itemAmount[month]) }}
                            </td>
                          </template>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.po) }}
                          </td>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.non_po) }}
                          </td>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.remainingIo) }}
                          </td>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.gr) }}
                          </td>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.actual_non_po) }}
                          </td>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.remainingPo) }}
                          </td>
                          <td class="font-weight-bold text-right sticky-amount">
                            {{ idr(item.data.itemAmount.remainingNonPo) }}
                          </td>
                          <td colspan="2" class="sticky-amount"></td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="47" class="text-center">
                            No data displayed
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-col>
              </v-card-text>
              <v-card-actions class="text-right">
                <v-spacer></v-spacer>
                <v-flex xs2 right class="mr-2">
                  <v-btn id="btn-back" dark color="red" @click="prevPage">
                    Back
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-layout>

    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import Swal from 'sweetalert2';
// import moment from 'moment';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import summaryAmount from '@/components/summaryAmount';

export default {
  name: 'SpendingReportIndex',
  props: ['yearFilter'],
  components: {
    'summary-amount': summaryAmount,
    'progress-dialog': ProgressDialog
    // VuePerfectScrollbar
  },
  mixins: [ACLMixin, LoginAsMixin],
  data() {
    return {
      initializing: false,
      scrollSettings: {
        maxScrollbarLength: 340
      },
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'CONSOLIDATED REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      tab: 0,
      profile_id: localStorage.getItem('profile_id'),
      totalItems: 0,
      options: {
        itemsPerPage: 10
      },
      lastPage: 0,
      filterBy: [],
      headers: [],
      panelSummary: [],
      items: [],
      item: {},
      itemAmount: {},
      summary: {
        totalBudget: 0,
        totalBudgetEuro: 0,
        totalSpending: 0,
        totalSpendingEuro: 0,
        remaining: 0,
        remainingEuro: 0
      },
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
        'Q1',
        'Q2',
        'Q3',
        'Q4',
        'Full Year IO'
      ],
      monthsCheck: [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
        'q1',
        'q2',
        'q3',
        'q4',
        'full_year_io'
      ],
      baseUrl: process.env.VUE_APP_BASE_URL
    };
  },
  computed: {
    filterYear() {
      return this.yearFilter ? this.yearFilter.split('-') : '';
    },
    yearInfo() {
      return this.filterYear[0] + '-' + this.filterYear[1];
    },
    division_ids() {
      return this.$route.query.divisions
        ? this.$route.query.divisions.split(',')
        : '';
    },
    filter() {
      return this.$route.query.filter
        ? this.$route.query.filter.split('&filter[]=').slice(1)
        : '';
    },
    paramDownload() {
      return this.$route.query.filter ? this.$route.query.filter : '';
    }
  },
  watch: {
    items: {
      handler(newVal) {
        if (this.items.length > 0) {
          this.options = newVal[this.tab].data.options;
        }
      },
      deep: true
    },
    'options.itemsPerPage'() {
      this.getData();
    },
    'options.page'() {
      this.getData();
    }
  },
  mounted() {
    // this.filterBy = this.$route.query.paramFilter;
    this.resetTab();
    this.getData();
  },
  methods: {
    getData() {
      this.progressDialogLoading = true;
      let options =
        this.items.length > 0
          ? this.copy(this.items[this.tab].data.options)
          : this.copy(this.options);
      let { page, itemsPerPage } = options;
      let divisionId =
        this.items.length > 0 ? this.items[this.tab].id : this.division_ids[0];
      let params = {
        type: 'report',
        page,
        limit: itemsPerPage,
        profileId: this.profile_id,
        divisionId: divisionId,
        startYear: this.filterYear[0],
        endYear: this.filterYear[1],
        filter: this.filter
      };
      return this.$store
        .dispatch('spendingDynamic/getConsolidatedReport', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            if (this.items.length === 0) {
              this.filterBy = data.data.filterBy;
              let items = [];
              for (let i = 0; i < data.data.divisions.length; i++) {
                items.push({
                  ...data.data.divisions[i],
                  data: {
                    dataIO: [],
                    itemAmount: {},
                    totalItems: 0,
                    options: {
                      itemsPerPage: data.data.result.pagination.per_page,
                      page: 1
                    },
                    lastPage: 0
                  }
                });
              }
              this.items = items;
              this.getSummary(params);
            }
            let item = {
              dataIO: [],
              itemAmount: {},
              totalItems: 0,
              options: {
                itemsPerPage: data.data.result.pagination.per_page,
                page: 1
              },
              lastPage: 0
            };
            item.totalItems = data.data.result.total_data;
            item.lastPage = data.data.result.pagination.last_page;
            page = data.data.result.pagination.current_page;
            itemsPerPage = data.data.result.pagination.per_page;
            item.options = { page, itemsPerPage };

            item.dataIO = data.data.result.result;
            item.itemAmount = data.data.totalAllRes;

            this.items[this.tab].data = item;
            this.totalItems = this.items[this.tab].data.totalItems;
            this.lastPage = this.items[this.tab].data.lastPage;
            // this.options = this.items[this.tab].data.options;
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getSummary(params) {
      this.progressDialogLoading = true;
      let payload = {
        profileId: params.profileId,
        divisionId: params.divisionId,
        startYear: params.startYear,
        endYear: params.endYear,
        filter: this.filter
        // divisions: params.divisions,
        // groups: params.groups,
        // budgetOwners: params.budgetOwners
      };
      return this.$store
        .dispatch('spendingDynamic/getSummaryConsolidate', payload)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.summary = data.data;
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    changeTab(item) {
      clearTimeout(this.timeout);
      if (item.data.dataIO.length === 0) {
        this.progressDialogLoading = true;
        this.timeout = setTimeout(() => {
          this.getData();
        }, 900);
      }
    },
    resetTab() {
      this.items = [];
      this.tab = 0;
    },
    refresh() {
      this.resetTab();
      this.getData();
    },
    prevPage() {
      this.$router.go(-1);
    },
    downloadData() {
      let divId =
        this.items.length > 0
          ? this.items[this.tab].id
          : this.$route.query.divisions;
      let startYear = this.filterYear[0];
      let endYear = this.filterYear[1];
      let profile_id = this.profile_id;
      let type = 'export';
      window.open(
        this.baseUrl +
          '/v2/report/consolidate?profileId=' +
          profile_id +
          '&startYear=' +
          startYear +
          '&endYear=' +
          endYear +
          '&type=' +
          type +
          '&divisionId=' +
          divId +
          this.paramDownload +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style>
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
</style>
